<template>
  <div>
    <div class="header pt-2">
      <span class="ap-title ap-title__main">{{ $t('diagnosis.batchActionsModal.searchTitle') }}</span>
    </div>
    <b-row>
      <b-col
        class="scroll-area"
        md
        sm="4"
      >
        <b-button-group
          size="sm"
          class="w-100"
        >
          <b-button
            qa="batchAction-case-search"
            class="btn__outline"
            :class="{'active':activeCaseSearch}"
            @click="activeCaseSearch = true"
          >
            {{ $tc('global.case', 2) }}
          </b-button>
          <b-button
            qa="batchAction-sample-search"
            class="btn__outline"
            :class="{'active':!activeCaseSearch}"
            @click="activeCaseSearch = false"
          >
            {{ $tc('global.sample', 2) }}
          </b-button>
        </b-button-group>
        <div class="mt-3">
          <div class="form-label">
            <label>
              {{ $t('diagnosis.batchActionsModal.caseType') }} *
            </label>
          </div>
          <vt-combo-select
            v-model="caseTypeSelected"
            v-validate="'required'"
            class="nowrap"
            track-by="id"
            :option-loader="getCaseTypes"
            label="descriptionInLaboratory"
          />
        </div>
        <div class="mt-3">
          <span class="ap-title ap-title__section">{{ $t('diagnosis.batchActionsModal.range') }}</span>
          <div class="d-flex">
            <div class="mt-2 pr-1">
              <div class="form-label">
                <label>
                  {{ $t('diagnosis.batchActionsModal.since') }}
                </label>
              </div>
              <vt-input
                v-model="caseNumberFrom"
                size="sm"
                type="text"
              />
            </div>
            <div class="mt-2 pl-1">
              <div class="form-label">
                <label>
                  {{ $t('diagnosis.batchActionsModal.to') }}
                </label>
              </div>
              <vt-input
                v-model="caseNumberTo"
                size="sm"
                type="text"
              />
            </div>
          </div>
        </div>
        <div class="mt-3">
          <span class="ap-title ap-title__section">{{ $t('diagnosis.batchActionsModal.registryDate') }}</span>
          <div class="mt-2">
            <div class="form-label">
              <label>
                {{ $t('diagnosis.batchActionsModal.since') }}
              </label>
            </div>
            <vt-date-picker
              :model="registryDateFrom"
              @update="registryDateFrom = $event"
            />
          </div>
          <div class="mt-2">
            <div class="form-label">
              <label>
                {{ $t('diagnosis.batchActionsModal.to') }}
              </label>
            </div>
            <vt-date-picker
              :model="registryDateTo"
              @update="registryDateTo = $event"
            />
          </div>
        </div>
        <div
          v-if="!activeCaseSearch"
          class="mt-3"
        >
          <span class="ap-title ap-title__section">{{ $t('diagnosis.batchActionsModal.ontology') }}</span>
          <div class="mt-2">
            <div class="form-label">
              <label>
                {{ $t('diagnosis.batchActionsModal.sampleType') }}
              </label>
            </div>
            <vt-combo-select
              v-model="sampleFilters.sampleType"
              :open-direction="'top'"
              :option-loader="loadSampleTypes"
              track-by="id"
              label="description"
              class="nowrap"
            />
          </div>
          <div class="mt-2">
            <div class="form-label">
              <label>
                {{ $t('diagnosis.batchActionsModal.location') }}
              </label>
            </div>
            <vt-combo-select
              v-model="sampleFilters.topographicCode"
              :open-direction="'top'"
              :option-loader="loadTopographicCodes"
              track-by="id"
              label="description"
              class="nowrap"
            />
          </div>
          <div class="mt-2">
            <div class="form-label">
              <label>
                {{ $t('diagnosis.batchActionsModal.procedure') }}
              </label>
            </div>
            <vt-combo-select
              v-model="sampleFilters.procedure"
              :open-direction="'top'"
              :option-loader="loadProcedures"
              track-by="id"
              label="description"
              class="nowrap"
            />
          </div>
          <div class="mt-2">
            <div class="form-label">
              <label>
                {{ $t('diagnosis.batchActionsModal.mostLikelyDiagnosis') }}
              </label>
            </div>
            <vt-combo-select
              v-model="sampleFilters.mostLikelyMorphologicCode"
              :open-direction="'top'"
              :option-loader="loadMostLikelyMorphologicCodes"
              track-by="id"
              class="nowrap"
              label="description"
            />
          </div>
        </div>
        <div class="mt-5">
          <b-row>
            <b-col class="pr-1">
              <b-button
                qa="batchAction-reset-search"
                block
                size="sm"
                class="btn__outline"
                @click="resetData"
              >
                {{ $t('diagnosis.batchActionsModal.reset') }}
              </b-button>
            </b-col>
            <b-col class="pl-1">
              <b-button
                qa="batchAction-search"
                :disabled="!caseTypeSelected"
                block
                size="sm"
                class="btn--primary"
                @click="doSearch()"
              >
                {{ $t('diagnosis.batchActionsModal.search') }}
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col>
        <b-container
          fluid
          class="results-area"
          :class="{'h-100':!searchDone}"
        >
          <b-row :class="{'h-100':!searchDone}">
            <b-col :class="{'h-100':!searchDone}">
              <div
                v-if="!searchDone"
                class="empty-search full-bordered h-100 d-flex flex-column align-items-center justify-content-center"
              >
                <div
                  class="empty-section text-center mb-3"
                  style="margin-top:0"
                >
                  <div class="pb-3">
                    <i
                      class="fal fa-th-list tertiary-color"
                      aria-hidden="true"
                    />
                  </div>
                  <span class="tertiary-color">
                    {{ $t('diagnosis.batchActionsModal.emptySearchTitle') }}
                  </span>
                </div>
                <b-row class="w-100 px-5 mt-5 d-flex justify-content-around">
                  <b-col
                    cols="4"
                    class="d-flex align-items-center justify-content-center"
                  >
                    <div class="d-flex flex-column align-items-center justify-content-center text-center">
                      <i
                        class="main fal fa-search fa-2x m-3"
                        aria-hidden="true"
                      />
                      <span>{{ $t('diagnosis.batchActionsModal.emptySearchHelp1') }}</span>
                    </div>
                  </b-col>
                  <b-col
                    cols="4"
                    class="d-flex align-items-center justify-content-center"
                  >
                    <div class="d-flex flex-column align-items-center justify-content-center text-center">
                      <i
                        class="main fal fa-list fa-2x m-3"
                        aria-hidden="true"
                      />
                      <span>{{ $t('diagnosis.batchActionsModal.emptySearchHelp2') }}</span>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div
                v-if="searchDone"
                class="grid-container full-bordered"
              >
                <grid-header
                  :gridtitle="`${selectedRows.length} ${$tc('diagnosis.modals.usersSelected', selectedRows.length)}`"
                >
                  <b-col class="d-flex justify-content-end">
                    <button
                      v-tooltip="$t('global.cleanFilter')"
                      type="button"
                      class="btn btn__icon btn__icon--primary p-0 btn-secondary"
                      @click="clearFilter()"
                    >
                      <i
                        class="far fa-filter"
                        aria-hidden="true"
                      />
                    </button>
                  </b-col>
                </grid-header>

                <vt-grid
                  :key="gridKey"
                  pagination
                  class="batch-actions-grid"
                  :grid-options="gridOptions"
                  :column-defs="columnDefs"
                />
              </div>
            </b-col>
            <b-col
              v-if="searchDone"
              lg="3"
              md="4"
              sm="5"
              class="selection-zone full-bordered"
            >
              <div
                v-if="searchDone"
                qa="batchAction-add-element"
                class="float-button d-flex align-items-center justify-content-center"
                @click="addElements()"
              >
                <i
                  class="fal fa-arrow-right"
                  aria-hidden="true"
                />
              </div>
              <div
                v-if="selectedElements"
                class="text-center p-3 d-flex align-items-center justify-content-between"
              >
                <span class="ap-title ap-title__section">{{ selectedElements.length }} {{ $tc('diagnosis.batchActionsModal.element', selectedElements.length) }} {{ $t('diagnosis.batchActionsModal.inTotal') }}</span>
                <b-button
                  v-tooltip="$t('diagnosis.batchActionsModal.cleanSelection')"
                  class="btn__icon btn__icon--primary  px-2"
                  qa="batchAction-reset-selection"
                  @click="selectedElements = []"
                >
                  <i
                    class="far fa-eraser"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
              <div
                v-if="selectedElements"
                class="scroll-area"
              >
                <div
                  v-for="(element, index) in selectedElements"
                  :key="index"
                  class="selected-element px-3 d-flex align-items-center justify-content-between"
                >
                  <span>{{ element.label || element.caseNumber }}</span>
                  <b-button
                    qa="batchAction-delete-element"
                    class="btn__icon btn__icon--primary alt-btn  px-2"
                    @click="deleteElement(index)"
                  >
                    <i
                      class="far fa-times"
                      aria-hidden="true"
                    />
                  </b-button>
                </div>
              </div>
              <div
                v-if="!selectedElements"
                class="text-center py-4"
              >
                <span>{{ $t('diagnosis.batchActionsModal.noAddedItem') }}</span>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import GridHeader from '@/components/GridHeader'
import VtGrid from '@/components/VtGrid/VtGrid'
import CommonCaseTypeServices from '@/api/resources/common/commonCaseTypeServices'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import { batchActionsCaseColumnDefs } from '@/modules/diagnosisModule/components/BatchActionsModal/views/batch-actions-case.column-defs'
import { batchActionsSampleColumnDefs } from '@/modules/diagnosisModule/components/BatchActionsModal/views/batch-actions-sample.column-defs'
import { BatchActionsDatasource } from '@/modules/diagnosisModule/components/BatchActionsModal/batch-actions-datasource'
import { commonSampleClassificationService } from '@/api/resources/common/sample-classification/sample-classification.service'
import { GridUtils } from '@/shared/util/grid-utils'

export default {
    name: 'ElementsSelectionView',
    components: { GridHeader, VtGrid },
    data() {
        return {
            gridKey: 0,
            selectedRows: [],
            sampleFilters: {},
            datasource: null,
            gridApi: null,
            activeCaseSearch: true,
            registryDateFrom: null,
            registryDateTo: null,
            caseNumberFrom: null,
            caseNumberTo: null,
            caseTypeSelected: null,
            selectedElements: [],
            searchDone: false,
            columnDefs: []
        }
    },
    computed: {
        laboratoryId() {
            return this.$store.getters.labId
        },
        gridOptions() {
            return {
                sideBar: gridSideBarConfig,
                getContextMenuItems: this.getContextMenuItems,
                onRowDoubleClicked: (params) => this.addElements([params.data]),
                onGridReady: this.onGridReady,
                onSelectionChanged: this.onSelectionChanged
            }
        }
    },
    watch: {
        selectedElements() {
            this.$emit('disable-next-button', !this.selectedElements.length)
        }
    },
    methods: {
        async getCaseTypes() {
            return CommonCaseTypeServices.getActiveCaseTypesByLaboratory(this.laboratoryId)
        },
        async loadTopographicCodes() {
            return commonSampleClassificationService.getCommonTopographicCodesSampleClassificationsByLaboratory(
                { laboratoryId: this.laboratoryId }
            )
        },
        async loadSampleTypes() {
            return commonSampleClassificationService.getCommonSampleTypeSampleClassificationsByLaboratory(
                { laboratoryId: this.laboratoryId }
            )
        },
        async loadMostLikelyMorphologicCodes() {
            return commonSampleClassificationService.getCommonMostLikelyMorphologicCodesSampleClassificationsByLaboratory(
                { laboratoryId: this.laboratoryId }
            )
        },
        async loadProcedures() {
            return commonSampleClassificationService.getCommonProceduresSampleClassificationsByLaboratory(
                { laboratoryId: this.laboratoryId }
            )
        },

        resetData() {
            this.registryDateFrom = null
            this.registryDateTo = null
            this.caseNumberFrom = null
            this.caseNumberTo = null
            this.caseTypeSelected = null
            this.sampleFilters = {}
        },
        deleteElement(elementIndex) {
            this.selectedElements.splice(elementIndex, 1)
        },
        addElements(elementsClicked) {
            const elements = elementsClicked ?? this.selectedRows
            elements.forEach((element) => {
                const elementAdded = this.selectedElements.find((selectedElement) => element.caseNumber
                    ? selectedElement.caseNumber && selectedElement.id === element.id
                    : !selectedElement.caseNumber && selectedElement.id === element.id)
                if (!elementAdded) {
                    this.selectedElements.push(element)
                }
            })
        },

        onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()
        },
        getContextMenuItems(params) {
            return [
                {
                    name: this.$tc('diagnosis.batchActionsModal.add'),
                    action: () => this.addElements([params?.node.data])
                }
            ]
        },
        clearFilter() {
            this.gridApi?.setFilterModel(null)
        },
        _setDatasource(externalFilterModel) {
            const gridParams = {
                caseTypeId: this.caseTypeSelected.id
            }

            this.datasource =
                new BatchActionsDatasource(
                    this.laboratoryId,
                    this.activeCaseSearch,
                    gridParams,
                    externalFilterModel)
        },
        onGridReady({ api }) {
            this.gridApi = api
            this.gridApi.setServerSideDatasource(this.datasource)
        },
        _searchSamples() {
            const externalFilterModel = {}
            if (this.caseNumberFrom && this.caseNumberTo) {
                externalFilterModel['caseStudy.casCasenumber'] = {
                    filterType: 'text',
                    type: 'inRange',
                    filter: this.caseNumberFrom,
                    filterTo: this.caseNumberTo
                }
            }
            if (this.registryDateFrom && this.registryDateTo) {
                externalFilterModel['caseStudy.casRegistrationDate'] =
                    GridUtils.getDateTimeFilterModel('inRange', this.registryDateFrom, this.registryDateTo)
            }
            if (this.sampleFilters.sampleType) {
                externalFilterModel['sampleType.id'] =
                    GridUtils.getNumberFilterModel('equals', this.sampleFilters.sampleType.id)
            }
            if (this.sampleFilters.topographicCode) {
                externalFilterModel['topographicCode.id'] =
                    GridUtils.getNumberFilterModel('equals', this.sampleFilters.topographicCode.id)
            }
            if (this.sampleFilters.procedure) {
                externalFilterModel['procedure.id'] =
                    GridUtils.getNumberFilterModel('equals', this.sampleFilters.procedure.id)
            }
            if (this.sampleFilters.mostLikelyMorphologicCode) {
                externalFilterModel['mostLikelyMorphologicCode.id'] =
                    GridUtils.getNumberFilterModel('equals', this.sampleFilters.mostLikelyMorphologicCode.id)
            }

            this.columnDefs = batchActionsSampleColumnDefs()
            this._setDatasource(externalFilterModel)
        },
        _searchCases() {
            const externalFilterModel = {}
            if (this.caseNumberFrom && this.caseNumberTo) {
                externalFilterModel.casCasenumber = {
                    filterType: 'text',
                    type: 'inRange',
                    filter: this.caseNumberFrom,
                    filterTo: this.caseNumberTo
                }
            }
            if (this.registryDateFrom && this.registryDateTo) {
                externalFilterModel.casRegistrationDate =
                    GridUtils.getDateTimeFilterModel('inRange', this.registryDateFrom, this.registryDateTo)
            }

            this.columnDefs = batchActionsCaseColumnDefs()
            this._setDatasource(externalFilterModel)
        },
        doSearch() {
            if (this.activeCaseSearch) {
                this._searchCases()
            } else {
                this._searchSamples()
            }
            this.gridKey++
            this.searchDone = true
        }
    }
}
</script>

<style scoped>

</style>
